import script from "./LogoutToolbarButton.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoutToolbarButton.vue?vue&type=script&setup=true&lang=js"

import "./LogoutToolbarButton.vue?vue&type=style&index=0&id=0a846560&scoped=true&lang=css"

import exportComponent from "C:\\Source\\Tms\\TmsUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a846560"]])

export default __exports__